import React from "react";
import { useCan } from "@/app/_utils/sessionClient";

/**
 * Hide a control the user cannot use.
 *
 *   <Can permission={PERMISSIONS.ORDER_REFUND}><RefundButton /></Can>
 *
 * Presentation only. The endpoint behind the control is gated server-side too, and that
 * is the check that counts.
 */
export function Can({
  permission,
  children,
  fallback = null,
}: {
  permission: string;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}) {
  return useCan(permission) ? <>{children}</> : <>{fallback}</>;
}

export default Can;
